import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown, DropdownProps } from 'semantic-ui-react'

import { IColumn } from '@cbgms/components/grid/Types'

import { KnockOperator } from '../Knock/KnockTypes'
import { TooltipButton } from '../../form/TooltipButton'
import { PopupDropdown } from './PopupDropdown'

export interface IOperatorProps extends Pick<DropdownProps, 'style'> {
  operators: KnockOperator[]
  operator?: KnockOperator
  onChange?: (value: Pick<IColumn, 'filterOperator'>) => void
}

export type OperatorProps = IOperatorProps

const OperatorFilter: React.FC<OperatorProps> = props => {
  const { t } = useTranslation()
  const { operators, onChange, ...rest } = props

  return (
    <PopupDropdown
      trigger={
        // <button> behaviour uses "type='submit'" by default if used in <form>, so set "type='button"' to surpress this behaviour,
        // because we don't want this button to cause a form submit.
        <TooltipButton type='button' title={t('operators.tooltip_filter')} style={{ marginTop: 7, marginBottom: 7 }} icon='filter' />
      }
      {...rest}
    >
      <Dropdown.Menu>
        {operators.map(operator => (
          <Dropdown.Item
            key={operator}
            disabled={operator === props.operator}
            onClick={() => onChange && onChange({ filterOperator: operator })}
          >
            {t(`operators.${operator}`)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </PopupDropdown>
  )
}

export default React.memo(OperatorFilter)
